module.exports = __webpack_public_path__ + "static/media/car.34bf3694.png";